import { render, staticRenderFns } from "./ic-dropdown.vue?vue&type=template&id=6025551c&"
import script from "./ic-dropdown.vue?vue&type=script&lang=js&"
export * from "./ic-dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports